export function aboutVideoPop() {
    const playTriggers = document.querySelectorAll('.play-button');
    const popup = document.getElementById('video-popup');
    const closeBtn = document.getElementById('close-popup');
    const videoIframe = document.getElementById('video-iframe');

    if (playTriggers.length === 0 || !popup || !closeBtn || !videoIframe) {
        return;
    }

    const baseSrc = videoIframe.getAttribute('src');

    if (!baseSrc) return;

    const openPopup = () => {
        videoIframe.src = `${baseSrc}?autoplay=1`;
        popup.classList.add('active');
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const closePopup = () => {
        videoIframe.src = '';
        popup.classList.remove('active');
        document.body.style.overflow = 'auto'; // Restore scrolling
    };

    // trigger the popup.
    playTriggers.forEach(trigger => {
        trigger.addEventListener('click', openPopup);
    });

    // Close the popup
    closeBtn.addEventListener('click', closePopup);

    // CLose when the overlay is clicked.
    popup.addEventListener('click', (e) => {
        if (e.target === popup) {
            closePopup();
        }
    });
}